





















































































import { Mixins, Component } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';
import * as U from '@/utils';
import * as E from '@/enums';

import AxAPI from '@/api';

type Group = I.AxZone;
type Item = I.AntipassDetail;

type GroupListPanel = I.AxGroupListPanel<Group, Item>;
type PageInfo = I.AntipassPageInfo;

type DataItem = U.DataItem<unknown, State>;
type DataStore = U.DataStore<unknown, never>;

const DataStore = U.DataStore;

class State {
  name: string;
  code: number;
  zoneCode: number;
  zoneName: string;
  etc: string;
  listAllAcu: I.AcuData[];
  listAcu: I.AcuData[];
  itemStatus: E.ItemStatus;

  constructor() {
    this.name = '' as never;
    this.code = '' as never;
    this.zoneName = '' as never;
    this.zoneCode = '' as never;
    this.etc = '' as never;

    this.listAllAcu = [];
    this.listAcu = [];

    this.itemStatus = E.ItemStatus.None;
  }
}

abstract class BaseClass extends Mixins(AxPage) {
  API!: AxAPI;
  panel!: GroupListPanel;
  pageInfo!: PageInfo;
  dataItem!: DataItem;
}

interface BaseInterface extends BaseClass {}

@Component
class ApiHandler extends BaseClass {
  async getPageInfo() {
    const result = await this.API.call.antipass.get();
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async updateItem(item: I.AntipassUpdateReq) {
    const result = await this.API.call.antipass.antipassUpdate(item);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }
}

@Component
class DataItemHandler extends BaseClass {
  dataItems: DataItem[] = [
    {
      name: '안티패스 데이터',
      store: {} as DataStore,
      search: '',
      description: [],
      state: new State()
    }
  ];

  get dataItem() {
    return this.dataItems[0];
  }
}

@Component
class GroupPanelHandler extends BaseClass {
  onListGroupChanged(group?: Group) {
    if (!this.pageInfo || !group) return;
    if (this.panel.items) {
      this.panel.items = this.pageInfo.listAntipass.filter(x => x.zoneCode === group.code);
      this.dataItem.state.listAcu = [];
    }
  }

  async onListItemChanged(item?: Item) {
    if (item) {
      this.dataItem.state.itemStatus = E.ItemStatus.Update;
      this.dataItem.state.listAllAcu = [];

      await this.$nextTick();

      this.dataItem.state.listAllAcu = this.pageInfo.listAcu.filter(
        x => x.zoneCode === item.zoneCode
      );

      this.dataItem.state.zoneCode = item.zoneCode;
      this.dataItem.state.code = item.code;
      this.dataItem.state.name = item.name;
      this.dataItem.state.listAcu = JSON.parse(JSON.stringify(item.listAcu));
      this.dataItem.state.etc = item.etc;
    } else {
      this.dataItem.state.itemStatus = E.ItemStatus.None;
      this.dataItem.state = new State();
    }
  }

  onListAddClicked(group: Group) {
    this.dataItem.state = new State();
    this.dataItem.state.code = 0;
    this.dataItem.state.name = '';
    this.dataItem.state.etc = '';
    this.dataItem.state.zoneCode = group.code;
    this.dataItem.state.zoneName = group.name;
    this.dataItem.state.itemStatus = E.ItemStatus.New;

    this.dataItem.state.listAllAcu = this.pageInfo.listAcu.filter(x => x.zoneCode === group.code);
  }
}

@Component
class BaseData extends Mixins(AxPage) implements BaseInterface {
  dataItem!: DataItem;

  panel: GroupListPanel = {
    groups: [],
    items: [],
    group: -1,
    item: -1
  };

  pageInfo = {} as PageInfo;

  get remainAcuList() {
    if (!this.pageInfo.listAcu) return [];
    if (!this.dataItem.state.listAcu) return this.pageInfo.listAcu;
    return this.pageInfo.listAcu
      .filter(x => this.dataItem.state.listAcu.findIndex(y => y.name === x.name) === -1)
      .sort((a, b) => a.name.localeCompare(b.name));
  }

  get applyAcuList() {
    if (!this.dataItem.state.listAcu) return [];
    return this.dataItem.state.listAcu.sort((a, b) => a.name.localeCompare(b.name));
  }
}

const Handlers = Mixins(ApiHandler, DataItemHandler, GroupPanelHandler);

@Component
export default class Antipass extends Mixins(BaseData, Handlers) {
  async prepare() {
    const pageInfo = await this.getPageInfo();

    console.log(pageInfo);

    if (pageInfo) {
      this.pageInfo = pageInfo;
      this.panel.groups = this.getZoneList();
    }
  }

  async onSaveClicked() {
    console.log('onSaveClicked', this.dataItem.state.listAcu);

    const { itemStatus, listAcu } = this.dataItem.state;
    if (itemStatus === E.ItemStatus.None) return;

    const updateFlag =
      itemStatus === E.ItemStatus.New ? E.EUpdateFlag.Insert : E.EUpdateFlag.Update;

    const { code, name, etc, zoneCode } = this.dataItem.state;

    if (name.length === 0) {
      await this.showErrorModal('오류', '이름을 입력하세요');
      return;
    }

    const title = '확인';
    const message =
      itemStatus === E.ItemStatus.New
        ? '입력한 아이템을 추가할까요?'
        : '선택한 아이템을 수정할까요?';
    const buttons = ['네', '아니오'];

    const confirm = await this.showConfirmModal(title, message, buttons);
    if (confirm !== 0) return;

    this.setLoading(true);
    const result = await this.updateItem({
      code,
      name,
      etc,
      zoneCode,
      updateFlag,
      listAcu
    });

    this.setLoading(false);
    if (!result) return;

    this.onUpdated(result, updateFlag);
  }

  async onClearClicked() {
    const confirm = await this.showConfirmModal('확인', '입력중인 내용을 취소할까요?', [
      '네',
      '아니오'
    ]);

    if (confirm === 0) {
      this.dataItem.state = new State();
    }
  }

  async onDeleteClicked() {
    const { code, name, etc, zoneCode, itemStatus } = this.dataItem.state;
    const listAcu = this.pageInfo.listAcu;

    if (itemStatus === E.ItemStatus.None) return;

    const updateFlag = E.EUpdateFlag.Delete;

    const confirm = await this.showConfirmModal('확인', '선택된 아이템을 삭제할까요?', [
      '네',
      '아니오'
    ]);
    if (confirm !== 0) return;

    this.setLoading(true);
    const result = await this.updateItem({
      updateFlag,
      code,
      name,
      etc,
      zoneCode,
      listAcu
    });

    this.setLoading(false);
    if (!result) return;

    this.onUpdated(result, E.EUpdateFlag.Delete);
  }

  async onUpdated(result: Item, updateFlag: E.EUpdateFlag) {
    if (!this.pageInfo) return;
    const prevGroup = this.panel.group;

    this.panel.groups = [];
    this.panel.items = [];

    await this.prepare();

    this.panel.group = prevGroup;
    await this.$nextTick();

    if (updateFlag !== E.EUpdateFlag.Delete) {
      this.panel.item = this.panel.items.findIndex(x => x.code === result.code);
    }

    if (updateFlag === E.EUpdateFlag.Insert) {
      this.dataItem.state.itemStatus = E.ItemStatus.Update;
      await this.showErrorModal('알림', '추가되었습니다');
    } else if (updateFlag === E.EUpdateFlag.Update) {
      await this.showErrorModal('알림', '수정되었습니다');
    } else if (updateFlag === E.EUpdateFlag.Delete) {
      this.dataItem.state = new State();
      this.panel.item = -1;
      await this.showErrorModal('알림', '삭제되었습니다');
    }
  }
}
